// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3588":"5ebf5d65","8688":"6a7ad95e"}[chunkId] + ".chunk.css";
};